"use strict";

module.exports = {
  fetch: global.fetch
};
//# sourceMappingURL=whatwg-fetch.js.map